<template lang="pug">
    div.password
        el-dialog(
            :title="currentTitle"
            :visible.async="passwordData.show"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="passwordData.model === 'reset'"
            width="620px"
            @close="closeDialog"
            center
        )
            el-form(
                :model="modifyPasswordForm"
                :rules="rules"
                ref="modifyPasswordForm"
                label-width="140px"
            )
                div.tips(
                    v-if="step === 1"
                ) 提示：密码必须为大写字母+小写字母+数字+特殊符号的组合，长度为8-20字符
                el-form-item(
                    prop="oldPassword"
                    label="当前密码："
                    v-if="step === 1 && passwordData.model === 'reset'"
                )
                    el-input(
                        v-model="modifyPasswordForm.oldPassword"
                        maxlength="20"
                        type="password"
                        placeholder="请输入密码"
                    )
                el-form-item(
                    prop="password"
                    :label="passwordData.model === 'reset' ? '设置新密码：': '输入密码：'"
                    v-if="step === 1"
                )
                    el-input(
                        v-model="modifyPasswordForm.password"
                        maxlength="20"
                        type="password"
                        placeholder="请输入密码"
                    )
                el-form-item(
                    prop="passwordConfirm"
                    :label="passwordData.model === 'reset' ? '再次输入新密码：': '再次输入密码：'"
                    v-if="step === 1"
                )
                    el-input(
                        v-model="modifyPasswordForm.passwordConfirm"
                        maxlength="20"
                        type="password"
                        placeholder="请输入密码"
                    )
            div.success(
                v-if="step === 2"
            )
                i.el-icon-success
                span {{ passwordData.model === 'firstSet' ? '密码设置成功' : '密码修改成功' }}
                div.successText 您可使用户名+密码/手机号+密码的方式登录凯励程CRM
            span(
                slot="footer"
            )
                el-button(
                    @click="handleSubmit"
                    style="width: 110px"
                    round
                    type="primary"
                ) {{buttonText}}
</template>

<script>
import { mapActions } from 'vuex';
import {
    loginApis,
} from '@/api';

export default {
    name: 'ModifyPassword',
    props: {
        passwordData: {
            type: Object,
            default: () => ({
                model: 'reset',
                userId: 0,
                show: true,
            }),
        },
    },
    data() {
        const validatePassword = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('密码必须为大写字母+小写字母+数字+特殊符号的组合，长度为8-20字符'));
            } else if (value.length < 8 || value.length > 20) {
                callback(new Error('密码长度为8-20位'));
            } else {
                callback();
            }
        };
        const validatePasswordConfirm = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.modifyPasswordForm.password) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            step: 1,
            buttonText: '提交',
            modifyPasswordForm: {
                password: '',
                passwordConfirm: '',
                oldPassword: '',
            },
            rules: {
                oldPassword: [
                    {
                        required: true,
                        message: '请输入当前密码',
                        trigger: 'blur',
                    },
                ],
                password: [
                    {
                        required: true,
                        validator: validatePassword,
                        trigger: 'blur',
                    },
                    {
                        pattern: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,20}$/,
                        message: '密码必须为数字+大写字母+小写字母+特殊符号的组合',
                        trigger: 'blur',
                    },
                ],
                passwordConfirm: [
                    {
                        required: true,
                        validator: validatePasswordConfirm,
                        trigger: 'blur',
                    },
                ],
            },
        };
    },
    computed: {
        currentTitle() {
            if (this.step === 2) {
                return this.passwordData.model === 'reset' ? '密码修改成功' : '密码设置成功';
            }
            return this.passwordData.model === 'reset' ? '修改密码' : '设置密码';
        },
    },
    methods: {
        ...mapActions('user', [
            'LogOut',
        ]),
        handleSubmit() {
            this.$refs.modifyPasswordForm.validate(async (valid) => {
                if (!valid) return;
                if (this.step === 1) {
                    try {
                        if (this.passwordData.model === 'reset') {
                            if (this.modifyPasswordForm.oldPassword === this.modifyPasswordForm.password) {
                                this.$message.error('新旧密码不能一样');
                                return;
                            }
                            await loginApis.resetPassword({
                                oldPassword: this.modifyPasswordForm.oldPassword,
                                password: this.modifyPasswordForm.password,
                            });
                        } else {
                            // 首次登陆设置密码完成后-->首次登陆设置店铺信息
                            const { code } = await loginApis.setPassword({
                                password: this.modifyPasswordForm.password,
                            });
                            if (code === 0) this.$emit('setPassWordCb');
                        }
                        this.step = 2;
                        this.buttonText = '确定';
                    } catch (err) {
                        throw new Error(err);
                    }
                    return;
                }
                if (this.step === 2) {
                    this.$message({
                        message: '密码修改成功',
                        type: 'success',
                    });
                    this.passwordData.show = false;
                    if (this.passwordData.model === 'reset') this.LogOut();
                }
                // 首次登陆密码设置成功点击‘知道了’
                if (this.currentTitle === '密码设置成功') this.$emit('closeSetPassWordCb');
            });
        },
        closeDialog() {
            this.passwordData.show = false;
        },
    },
};
</script>

<style scoped lang="scss">
    .password {
        .tips {
            text-align: center;
            margin-bottom: 10px;
            @include font_color(text_color_warning);
        }
        .success {
            display: flex;
            flex-direction: column;
            align-items: center;
            .el-icon-success {
                font-size: 56px;
                @include font_color(color_base_assist2);
            }
            span {
                margin: 15px 0 6px 0;
                @include font_weight(text_font_weight);
                @include font_size(text_emphasize);
            }
            .successText {
                margin-bottom: 20px;
            }
        }
    }
</style>
<style lang="scss">
    .password {
        .el-dialog .el-dialog__body {
            padding: 10px 30px 0 30px;
        }
        .el-dialog__footer {
            padding-top: 0;
        }
    }
</style>
